/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { BaseController } from '../../BaseController';

class AlarmSourceViewController extends BaseController {
    /** @ngInject */
    constructor(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log,
        alarmSourceService) {
        super(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log);
        this.alarmSourceService = alarmSourceService;
        this.$log.debug('Controller \'AlarmSourceView\' loaded');
    }

    $onInit() {
        super.$onInit();

        this.waitSpinnerService.visible = true;
        this.formDisabled = false;

        // The updateMode flag can be used to know the context in which this controller is running: creation or update.
        let initPromise;
        if (this.$stateParams.hasOwnProperty('id')) {
            this.updateMode = true;
            this.title = 'ui.alarmsource.update';
            initPromise = this.alarmSourceService.getEntity(this.$stateParams.id);
        } else {
            this.updateMode = false;
            this.title = 'ui.alarmsource.creation';
            initPromise = this.$q.resolve();
        }

        this.handleRestServiceCall(initPromise, entity => {
            this.pristineEntity = entity;
            this.reset();
        }).finally(() => {
            this.waitSpinnerService.visible = false;
        });
    }

    save() {
        this.formDisabled = true;
        let serviceActionPromise;
        if (this.updateMode) {
            serviceActionPromise = this.alarmSourceService.updateEntity(this.alarmSource);
        } else {
            serviceActionPromise = this.alarmSourceService.createEntity(this.alarmSource);
        }
        this.handleRestServiceCall(serviceActionPromise, () => {
            const message = 'ui.alarmsource.' + (this.updateMode ? 'updated' : 'created');
            this.notificationService.pushMessage(message, this.configuration.NOTIFIER_LEVEL_INFO);
            if (this.updateMode) {
                this.$state.reload();
            } else {
                this.$state.go('gmao.alarm.source.list');
            }
        }).finally(() => {
            this.formDisabled = false;
        });
    }

    reset() {
        this.alarmSource = angular.copy(this.pristineEntity);
    }
}

export const alarmSourceViewComponent = {
    template: require('./alarmsource-view.html'),
    controller: AlarmSourceViewController
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/alarm/component/AlarmSourceView.js